import { User } from '@cxstudio/user-administration/users/entities/user';

export class UserUtils {
	static isAdminOne = (user: User): boolean => {
		return user.userEmail === 'admin@clarabridge.com';
	};
	static isAdmin = (user: User): boolean => {
		return user.systemAdmin || user.liteAdmin;
	};
}